import { z } from 'zod';

export const reviewSchema = z.object({
  tenantId: z.string().min(1, 'Tenant ID is required'),
  userId: z.string().min(1, 'User ID is required'),
  userName: z.string().min(1, 'User name is required'),
  userPhotoURL: z.string().url().optional().or(z.literal('')),
  
  rating: z.number().min(1, 'Rating must be at least 1').max(5, 'Rating cannot exceed 5'),
  title: z.string().max(100, 'Title is too long').optional(),
  comment: z.string().min(10, 'Comment must be at least 10 characters').max(1000, 'Comment is too long'),
  
  visitDate: z.string().optional(), // Store as ISO string
  tripType: z.string().optional(),
  wouldRecommend: z.boolean().default(true),
  
  photos: z.array(z.string().url()).optional().default([]),
  
  isVerified: z.boolean().default(false),
  helpfulCount: z.number().default(0),
});

export type ReviewInput = z.infer<typeof reviewSchema>;
